import Modal from "@/components/Modal";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "promo-modal",
  data() {
    return {
      open: false,
    };
  },
  created() {
    this.fetchFlayers();
  },
  components: {
    Modal,
  },
  mounted() {
    this.open = this.flayerOpen;
  },
  computed: {
    ...mapGetters("flayers", {
      currentFlayer: "getFlayersShow",
      flayers: "getFlayersList",
    }),
    flayerOpen() {
      return (this.flayers.length > 0 && true) || false;
    },
  },
  methods: {
    ...mapActions("flayers", {
      fetchFlayers: "fetchList",
    }),
  },
};
